import Vue from "vue";
import VueCompositionAPI, { ref } from "@vue/composition-api";
Vue.use(VueCompositionAPI);
const DeclarationItem = ref([]);

const comment = ref("");
const market = ref(null);
const parcelType = ref();
const ParcelTypeInput = ref(1);

const repackaging = ref(true);

export const useDeclaration = () => {
    const getDeclarationItems = async (id) => {
        let res = null;
        try {
            res = await axios({
                url: `/api/declaration/item/${id}`,
                method: "GET",
            });
            DeclarationItem.value = res.data;
        } catch (error) {
            console.log(error.response);
        }
    };

    const onDelete = (index) => {
        const id = DeclarationItem.value[index].id;
        DeclarationItem.value.splice(index, 1);
        axios({
            url: `/api/declaration/item/delete`,
            method: "POST",
            data: {
                id: id,
            },
        });
    };

    const onSaveItem = async (data) => {
        return await axios({
            url: "/api/declaration/item/create",
            method: "POST",
            data: data,
        });
    };
    const onSaveDeclaration = async (date) => {
        return await axios({
            url: "/api/declaration",
            method: "POST",
            data: date,
        });
    };

    return {
        getDeclarationItems,
        DeclarationItem,
        onDelete,
        onSaveItem,
        comment,
        market,
        parcelType,
        ParcelTypeInput,
        onSaveDeclaration,
        repackaging,
    };
};
